import { ApiGetRequest, AppCompany } from 'types';

import { IUserRole } from 'modules/auth-session';

export enum EAppInvitationType {
  URL = 'url',
  EMAIL = 'email',
}

export interface IAppInvitation {
  id: number;
  type: EAppInvitationType;
  company: AppCompany;
  roles: IUserRole[];
  invitation_code: string;
  created_at: string;
  email: string | null;
  registration_url: string | null;
}

export interface FetchAppInvitationsPayload extends ApiGetRequest {
  filter_by_type?: string | null;
}

export interface AddAppInvitationPayload {
  type: EAppInvitationType;
  company_id: number;
  roles: number[];
  email?: string | null;
}

export interface ResendAppInvitationPayload {
  id: number;
}

export interface DeleteAppInvitationPayload extends ResendAppInvitationPayload {}
